import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: startDate => ({
        date: Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'itsmOpenTickets',
        endpoint:           endpoints.itsm.openTickets,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => ({
            results: !response.results ? [] : response.results.map(item => ({
                descState:        item.desc_state,
                orderNumber:      item.order_number,
                descType:         item.desc_type,
                descUrgency:      item.desc_urgency,
                lastUpdated:      item.last_updated,
                openedBy:         item.opened_by,
                shortDescription: item.short_description
            }))
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/itsmOpenTickets.js